import * as moment from 'moment';

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'date-picker',
	template: `
		<div [class]="classes">
			<ion-datetime
				#datetime
				show-default-buttons="true"
				[presentation]="presentation"
				[preferWheel]="preferWheel"
				(ionChange)="handleDateChange($event)"
				[min]="pastDate"
				[max]="futureDate"
				[value]="value"
			>
				<ion-buttons slot="buttons">
					<ion-button style="font-weight: bold;" color="primary" (click)="datetime.cancel(); handleCancel()">Cancel</ion-button>
					<ion-button style="font-weight: bold;" color="primary" (click)="datetime.confirm()">Select Date</ion-button>
				</ion-buttons>
			</ion-datetime>
		</div>
	`,
})
export class DatePickerComponent implements OnInit {
	private selectedDate = moment().format('YYYY-MM-DD');
	public pastDate = moment().subtract(1, 'M').format('YYYY-MM-DD');
	public futureDate = moment().add(1, 'year').format('YYYY-MM-DD');
	@Output() onDateChange: EventEmitter<string> = new EventEmitter();
	@Input('presentation') presentation = 'date';
	@Input('preferWheel') preferWheel = false;
	@Input('disablePastDates') disablePastDates = false;
	@Input('allowAllDates') allowAllDates = false;
	@Input('value') value = moment().format('YYYY-MM-DD');
	@Input('classes') classes: string = 'absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50';

	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - constructor
	 **-------------------------------------------------------------------------------------
	 */
	constructor() {}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - ngOnInit
	 **-------------------------------------------------------------------------------------
	 */
	ngOnInit() {
		if (this.value) this.value = moment(this.value).format('YYYY-MM-DD');
		if (this.disablePastDates) this.pastDate = moment().format('YYYY-MM-DD');
		if (this.allowAllDates) this.pastDate = moment().subtract(100, 'year').format('YYYY-MM-DD');
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - handleCancel
	 **-------------------------------------------------------------------------------------
	 */
	public handleCancel() {
		this.onDateChange.emit(this.value);
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - onDateChange
	 **-------------------------------------------------------------------------------------
	 */
	public async handleDateChange({ detail: { value } }) {
		this.selectedDate = value;
		this.onDateChange.emit(value);
	}
}
